'use client';

export default function QualtricsButton({ config = {} }) {
  const openQualtrics = () => {
    if (typeof window !== 'undefined') {
      window.checkout_confirm = false;
      if (window.loadQualtricsSiteIntercept) {
        window.loadQualtricsSiteIntercept();
      } else {
        console.error('loadQualtricsSiteIntercept no está disponible');
      }
    }
  };

  return (
    <div
      className=""
      onClick={openQualtrics}
      dangerouslySetInnerHTML={{
        __html: config.stylesBotton ?? '',
      }}
    />
  );
};
